document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.site-header');

    // Only run on homepage if that's the only place we want this specific behavior
    if (!document.body.classList.contains('template-index')) return;

    function handleScroll() {
        if (window.scrollY > 50) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on load
});
